import {
  beMessApiGetBeeCentralizedContentsTemplate,
  beMessApiGetBeeCentralizedContentsTemplates
} from 'Api/beMessApi'
import { beContentProviderGetListOfContents } from 'Api/beContentProvider'

import {
  CATEGORY_TEMPLATES_NO_IMG,
  CATEGORY_TEMPLATES_WITH_IMG
} from 'Components/Carousel/CarouselUtils'
import { beCampaignsBuilderApiGetEmailTemplatePreview } from 'Api/beCampaign'

export const getTemplates = async (withImage) => {
  const params = {
    filterBy: `Category == ${
      withImage ? CATEGORY_TEMPLATES_WITH_IMG : CATEGORY_TEMPLATES_NO_IMG
    }`,
    orderBy: 'Title asc'
  }

  const result = await beMessApiGetBeeCentralizedContentsTemplates(params)

  if (result && result.TotalItems > 0) {
    const items = result.Items.map((item) => {
      return {
        text: item.Title,
        imgSrc: `/templatecentral/bee/${item.Id}_thumb.svg`,
        category: item.Category,
        idTemplate: item.Id,
        templateType: item.Type
      }
    })
    return items
  }

  return { Items: [] }
}

export const getTemplateById = async (idTemplate) => {
  const res = await beMessApiGetBeeCentralizedContentsTemplate(idTemplate)
  return res
}

export const getSourceContent = async (idSource) => {
  const result = await beContentProviderGetListOfContents(idSource)

  if (result) {
    return result.TotalItems
  }

  return 0
}

export const getEmailTemplatePreview = async (
  idTemplate,
  idContentEndpoint
) => {
  const params = {
    endpoints: idContentEndpoint
  }

  const result = await beCampaignsBuilderApiGetEmailTemplatePreview(
    idTemplate,
    params
  )

  if (result) {
    return result.Content
  }

  return ''
}
